import { Fragment, useEffect, useRef, useState } from "react";
import {
  Outlet,
  useLoaderData,
  useSubmit,
  useNavigate,
} from "react-router-dom";
import { AlertContext } from "src/contexts/context";
import SideBar from "src/components/SideBar/sidebar";
import { getTokenDuration } from "src/util/auth";
import "./DashboardLayout.css";
import Socket from "src/components/Stomp/App_Stomp";
import Alert from "@mui/material/Alert";
import { Button } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import AlertTitle from "@mui/material/AlertTitle";
import { useRoleContext } from "src/hooks/use-alert";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AutorenewIcon from '@mui/icons-material/Autorenew';

//EVENTS

import "src/components/presentation.css";
import { EventsContext } from "src/contexts/context";
import DashboardLayout from "src/pages/DashBoardLayout/DashboardLayout";
import Testing from "src/components/Testing/testing";
import EventsSocket from "src/components/Events/Events_Stomp";

const alertObj = { status: false, messages: {} };

function Dashboard() {
  const { roles } = useRoleContext();
  const token = useLoaderData();
  const submit = useSubmit();
  const navigate = useNavigate();
  const fullscreenRef = useRef(null);

  useEffect(() => {
    // Update the roles state when resData changes
   
  }, [roles]);

  const onPageLoad = () => {
    console.log("Page loaded!");
    // enterFullscreen();
    // Perform any actions you want to take when the page loads here
  };

  // Use the useEffect hook with an empty dependency array
  useEffect(() => {
    // This function will be executed after the component has rendered for the first time
    onPageLoad();

    // If you need to clean up any resources when the component unmounts, you can return a function here
    return () => {
      // Clean-up logic (if needed)
    };
  }, []);

  const handleGoBack = () => {
    navigate(-1); // This navigates back to the previous route in your history
  };

  const handleRefresh = () => {
    window.location.reload();
  };
  

  useEffect(() => {
    if (!token) {
      return navigate("/auth");
    }

    if (token === "EXPIRED") {
      //   submit(null, { action: "/logout", method: "post" });
      localStorage.removeItem("token");
      localStorage.removeItem("expiration");
      return navigate("/auth");
    }

    const tokenDuration = getTokenDuration();

    setTimeout(() => {
      //   submit(null, { action: "/logout", method: "post" });
      localStorage.removeItem("token");
      localStorage.removeItem("expiration");
      return navigate("/auth");
    }, tokenDuration);
  }, [token, submit, navigate]);

  const isInIframe = window.self !== window.top;

  const [success, setSuccess] = useState([]);
  const [error, setError] = useState([]);
  const [ticketUpdate, setTicketUpdate] = useState({
    fatherId: null,
    status: null,
  }); //used to change ticket status and alarm status across all logged sessions
const [alarmPageUpdate, setAlarmPageUpdate]=useState(false) //use to refetch new alarm upon alarm from socket
const [ticketPageUpdate, setTicketPageUpdate]=useState(false) //use to refetch new tickets upon alarm from socket
  const [alarmError, setAlarmError] = useState([]); //state used to monitor alarms arrival through socket
  const [alarms, setAlarms] = useState({ data: [], counter: 0 });
  const [aiPredictions, setAiPredictions] = useState([]);
  const [alarmCount, setAlarmCount] = useState({});
  const [warningCount, setWarningCount] = useState({});
  const [newTicket,setNewTicket]= useState({});
  var closeAlert1 = success;
  var closeAlert2 = error;
  var closeAlarm = error.alarm;
  

  const redirectAlarm = (index) => {
    setTimeout(() => {
      setAlarmError((prev) => {
        if (prev[index] && prev[index].refetch) {
          prev[index] = {
            status: false,
            messages: {},
            index: index,
          };
        }
        return [...prev];
      });

      setAiPredictions((prev) => {
        if (prev[index] && prev[index].status) {
          prev[index] = {
            status: false,
            messages: {},
            index: index,
          };
        }
        return [...prev];
      });
    }, 3000);
    navigate(`/dashboard/alerts-and-notifications`);
  };

  // useEffect(() => {
  //   if (closeAlarms.length > 1) {
  //     console.log("start setTimeout");
  //     setTimeout(() => {
  //       setErrors((prev) =>{ prev[closeAlarms.length-1] = { status: false, messages: {}, index: closeAlarms.length-1}; return [...prev]});
  //       closeAlarms.shift();

  //     }, 5000);
  //   }
  // }, [closeAlarms]);

  useEffect(() => {
    if (closeAlert1.length > 0 || closeAlert2.length > 0) {
      // console.log("start setTimeout");
      setTimeout(() => {
        setSuccess((prev) => {
          prev[closeAlert1.length - 1] = {
            status: false,
            messages: {},
            index: closeAlert1.length - 1,
          };
          return [...prev];
        });
        setError((prev) => {
          prev[closeAlert2.length - 1] = {
            status: false,
            messages: {},
            index: closeAlert2.length - 1,
          };
          return [...prev];
        });
      }, 2000);
      setTimeout(() => {
        closeAlert1.shift();
        closeAlert2.shift();
      }, 5000);
    }
  }, [closeAlert1, closeAlert2, closeAlarm]);

  const containerRef = useRef(null);

  const [horizontalHeightPx, sethorizontalHeightPx] = useState(15);

  const [show, showEvents] = useState(false);

  const [iframePositions, setIframePositions] = useState({
    top: { id: "iframe1", component: <Outlet />, isOpen: true },
    bottom: { id: "iframe2", component: <Testing />, isOpen: true },
  });

  const handleShow = () => {
    sethorizontalHeightPx(200);
    showEvents(true);
  };

  const handleClose = () => {
    sethorizontalHeightPx(15);
    showEvents(false);
  };

  // const getHorizontalHeight = () => `${horizontalHeightPx}%`;

  const [events, setEvents] = useState({ data: [], counter: 0 });

  return (
    <EventsContext.Provider
      value={{
        setEvents,
        events,
      }}
    >
      {!isInIframe ? (
        <div className="app-container">
          <div
            className="top-left-area"
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              overflowX: "hidden",
            }}
          >
            <AlertContext.Provider
              value={{
                setSuccess,
                setError,
                alarms,
                alarmError,
                setAlarms,
                setAlarmError,
                setAlarmCount,
                alarmCount,
                setWarningCount,
                warningCount,
                ticketUpdate,
                setTicketUpdate,
                aiPredictions,
                setAiPredictions,
                alarmPageUpdate,
                setAlarmPageUpdate,
                ticketPageUpdate,
                setTicketPageUpdate,
                newTicket,
                setNewTicket
              }}
            >
              <div
                style={{
                  marginBottom: 2,
                  position: "fixed",
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: "100%",
                  overflow: "auto",
                  zIndex: 10000,
                  top: 10,
                  right: 20,
                  width: "25%",
                  height: "auto",
                }}
              >
                {error.map((e) => (
                  <Collapse in={e.status}>
                    <Alert
                      severity="error"
                      variant="filled"
                      onClose={() => {
                        setError((prev) => {
                          prev[e.index] = {
                            status: false,
                            messages: {},
                            index: e.index,
                          };
                          return [...prev];
                        });
                      }}
                      sx={{
                        mb: 2,
                        width: "auto",
                      }}
                    >
                      <AlertTitle>Error</AlertTitle>
                      {e.status && e.messages ? (
                        Object.entries(e.messages).map((message) => (
                          <div>
                            <strong>
                              {message[0]} - {message[1]}
                            </strong>
                          </div>
                        ))
                      ) : (
                        <div>
                          <strong>{e.message}</strong>
                        </div>
                      )}
                    </Alert>
                  </Collapse>
                ))}
                {success.map((s) => (
                  <Collapse in={s.status}>
                    <Alert
                      severity="success"
                      variant="filled"
                      onClose={() => {
                        setSuccess((prev) => {
                          prev[s.index].status = false;
                          prev[s.index].messages = {};
                          return [...prev];
                        });
                      }}
                      sx={{
                        mb: 2,
                        width: "auto",
                      }}
                    >
                      <AlertTitle>Success</AlertTitle>
                      <strong>{s.message}</strong>
                    </Alert>
                  </Collapse>
                ))}
                {alarmError.map((ae) => (
                  <Collapse in={ae.status}>
                    <Alert
                      severity="error"
                      variant="filled"
                      onClose={() => {
                        setAlarmError((prev) => {
                          prev[ae.index] = {
                            status: false,
                            messages: {},
                            index: ae.index,
                          };
                          return [...prev];
                        });
                      }}
                  
                    
                      sx={{
                        mb: 2,
                        width: "auto",
                      }}
                    >
                      <style>
                        {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
            `}
                      </style>
                      
                      <AlertTitle>Alarm</AlertTitle>
                      {ae.status && ae.messages ? (
                        Object.entries(ae.messages).map((message) => (
                          <div>
                            <strong>
                              {message[0]} - {message[1]}
                            </strong>
                          </div>
                        ))
                      ) : (
                        <div>
                          <strong>{ae.message}</strong>
                        </div>
                      )}
                      <Button variant="outlined"  color="inherit" size="small"   onClick={() => redirectAlarm(ae.index)}>
                          View Alarm
                        </Button>
                    </Alert>
                  </Collapse>
                ))}
                {aiPredictions.map((ai) => (
                  <Collapse in={ai.status}>
                    <Alert
                      severity="warning"
                      variant="filled"
                      onClose={() => {
                        setError((prev) => {
                          prev[ai.index] = {
                            status: false,
                            messages: {},
                            index: ai.index,
                          };
                          return [...prev];
                        });
                      }}
                      onClick={() => redirectAlarm(ai.index)}
                      sx={{
                        mb: 2,
                        width: "auto",
                        animation: "blink 2s infinite",
                      }}
                    >
                      <style>
                        {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
            `}
                      </style>
                      <AlertTitle>Alarm</AlertTitle>
                      {ai.status && ai.assetSerial ? (
                        //Object.entries(alarmError.messages).map((message) => (
                        <div>
                          <strong>
                            AI prediction for {ai.assetSerial} with following
                            message : {ai.prediction}
                          </strong>
                        </div>
                      ) : (
                        // ))
                        <div>
                          <strong>{ai.message}</strong>
                        </div>
                      )}
                    </Alert>
                  </Collapse>
                ))}
              </div>
              <Fragment>
                <div className={"splitl left"}>
                  <SideBar
                    elements={[
                      [
                        <button
                          className="mainBackButton"
                          onClick={handleGoBack}
                        >
                          <ArrowBackIosNewIcon style={{ color: "white" }} />
                        </button>,
                      ],
                      [
                        "/dashboard",
                        require("src/img/Home.png"),
                        "organization.view",
                        roles,
                      ],
                      [
                        "/dashboard/account-management",
                        require("src/img/users.png"),
                        "account.view",
                        roles,
                      ],
                      [
                        "dashboard/tasks",
                        require("src/img/Tasks.png"),
                        "task.view",
                        roles,
                      ],
                      [
                        "/dashboard/reports-history",
                        require("src/img/History.png"),
                        "report.view",
                        roles,
                      ],
                      [
                        "/dashboard/notebook",
                        require("src/img/Notebook.png"),
                        "note.view",
                        roles,
                      ],
                      [
                        "/dashboard/data-explorer",
                        require("src/img/dataExplorerGreyed.png"),
                        "data.view",
                        roles,
                      ],
                      [
                        "/dashboard/explore-complexes",
                        require("src/img/complex.png"),
                        "complex.view",
                        roles,
                      ],
                    ]}
                    sidebarWidth={"90%"} //with this props you can regulate the size of sidebar
                  />
                </div>
                <div
                  className={"split right"}
                  style={{
                    width: { width: isInIframe ? "100%" : "92%" },
                    position: "relative",
                  }}
                  ref={containerRef}
                >
                  <div
                    className={`horizontal-line-split ${show ? "active" : ""}`}
                    style={{
                      top: `calc(100% - ${horizontalHeightPx + 5}px)`,
                    }}
                    // onMouseDown={handleMouseDown}
                    onClick={!show ? handleShow : null}
                  />
                  <div
                    style={{
                      width: "100%",
                      height: `calc(100% - ${horizontalHeightPx + 15}px)`,
                      display: "flex",
                      overflowX: "hidden",
                    }}
                  >
                    <div className={"mainContainer"}>
                      <Socket />
                      {iframePositions.top.isOpen &&
                        iframePositions.top.component}
                    </div>
                  </div>
                  {iframePositions.bottom.isOpen && (
                    <div className="jj">
                      <div
                        className="bottom-area"
                        style={{
                          width: `calc(100% - 32px)`,
                          // height: "fit-content",
                          bottom: 0,
                          top: "unset",
                          height: `${horizontalHeightPx + 15}px`,
                          maxHeight: `${horizontalHeightPx + 15}px`,
                          // top: `calc(${getHorizontalHeight()} - 15px)`,
                        }}
                      >
                        <div className="closeButton closeButton-events">
                          {show && (
                            <button
                              className="close-button"
                              onClick={handleClose}
                            >
                              X
                            </button>
                          )}
                        </div>
                        <div
                          className="iframe-wrapper"
                          style={{
                            maxHeight: `calc(100% - 30px)`,
                            overflow: "auto",
                          }}
                        >
                          {show && iframePositions.bottom.component}
                        </div>
                      </div>
                    </div>
                  )}

                  <EventsSocket></EventsSocket>
                </div>
              </Fragment>
            </AlertContext.Provider>
          </div>
        </div>
      ) : (
        <div className="iframeRoot">
          <div className={"split right"}>
            <div className={"mainContainer"}>
              <AlertContext.Provider
                value={{
                  setSuccess,
                  setError,
                  alarms,
                  alarmError,
                  setAlarms,
                  setAlarmError,
                  setAlarmCount,
                  alarmCount,
                  setWarningCount,
                  warningCount,
                  ticketUpdate,
                  setTicketUpdate,
                  aiPredictions,
                  setAiPredictions,
                  alarmPageUpdate,
                  setAlarmPageUpdate,
                  ticketPageUpdate,
                  setTicketPageUpdate,
                  newTicket,
                setNewTicket
                }}
              >
                <button className="mainBackButton-windowing" onClick={handleRefresh}>
                  <AutorenewIcon style={{ color: "white" }} />
                </button>
                
                <Socket />
                {iframePositions.top.isOpen && iframePositions.top.component}
                <EventsSocket></EventsSocket>{" "}
                {/**sets value of monitor in windowing */}
              </AlertContext.Provider>
            </div>
          </div>
        </div>
      )}
    </EventsContext.Provider>
  );
}
export default Dashboard;
